module.exports = __webpack_public_path__ + "img/Suv_Back.a68115c9.svg";